const callback = {
    authenticating: 'Authenticating, please wait...',
    loginFailed: 'Login Failed (401 invalid_client)',
    loginFailedDesc: 'This usually means your App ID does not match the application type.',
    errorMessage: 'Error message:',
    retryLogin: 'Return to login page to retry',
  }

export default callback
